import { skipToken } from "@reduxjs/toolkit/query";
import { useMemo } from "react";
import { useAppSelector } from "../app/hooks";
import type { GetDataConfidenceRequest } from "../contracts";
import { getAgentResponseById } from "../models/agentResponseModels";
import { getToolResponseById, isCommercialSimulatorSubBrandToolResponse, isCommercialSimulatorToolResponse } from "../models/toolResponseModels";
import { selectCurrentCommercialPlan, selectMessages } from "../slices/chatSlice";

export const useDataConfidenceRequest = (): GetDataConfidenceRequest | typeof skipToken => {
    const currentPlan = useAppSelector(selectCurrentCommercialPlan);
    const messages = useAppSelector(selectMessages);

    const toolResponse = getToolResponseById(messages, currentPlan?.tool_use_id);
    const agentResponse = getAgentResponseById(messages, currentPlan?.tool_use_id);

    return useMemo(
        () => {
            if (!toolResponse || !agentResponse) {
                return skipToken;
            }

            // TODO: Will need to determine what makes sense here.
            const fromDate = new Date();
            const toDate = new Date();
            fromDate.setMonth(fromDate.getMonth() - 3);

            if (isCommercialSimulatorToolResponse(toolResponse)) {
                return {
                    product_ids: [toolResponse.tool_call_user_selection.sku_id],
                    retailer_id: toolResponse.tool_call_user_selection.retailer_id,
                    from_date: fromDate.toISOString(),
                    to_date: toDate.toISOString()
                };
            } else if (isCommercialSimulatorSubBrandToolResponse(toolResponse)) {
                if (!toolResponse.tool_call_user_selection.products || toolResponse.tool_call_user_selection.products.length === 0) {
                    return skipToken;
                }

                return {
                    product_ids: toolResponse.tool_call_user_selection.products.map(o => o.id),
                    retailer_id: toolResponse.tool_call_user_selection.products[0].retailer_id,
                    from_date: fromDate.toISOString(),
                    to_date: toDate.toISOString()
                };
            }

            return skipToken;
        },
        [agentResponse, toolResponse]
    );
};
